$(document).ready(function () {
    function initializeMarquee() {
        const slider_partners = $('.section-block-bar .items-wrap');

        if (slider_partners.length && !slider_partners.hasClass('marquee-initialized')) {
            slider_partners.liMarquee({
                scrollStop: false,
                circular: true,
                startShow: true,
                hoverStop: false,
                dragAndDrop: false,
            });

            slider_partners.addClass('marquee-initialized'); // Позначаємо ініціалізацію
        }
    }

    initializeMarquee();
});